import qs from 'qs';
import fetcher from '../modules/ajio-fetch';
import { fetchGetJSONReqOpts, fetchGetJSONResHandler } from '../modules/ajio-fetch/utils';
import { getSearchExpFlags } from '../utils/products';
import { getSearchFlags } from '../refresh/selectors/featureFlagsSelector';
import { getProductProps } from '../refresh/utils/productUtils';
import {getAmplitudeVariantPayload , getAmplitudeVariantPayloadMap} from '../utils/amplitudeCommon';

function fetchProductsApi(productIds, ABFlagObj, params = {}) {
  const query = new URLSearchParams();
  query.set('SearchExperimentFlag', JSON.stringify(ABFlagObj));

  if (params && Object.keys(params).length > 0) {
    for (const [key, value] of Object.entries(params)) {
      query.set(key, value);
    }
  }

  const url = `/api/p/fetchProducts/${productIds}?${query.toString()}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

function fetchDynamicProductsApi(widgetData = {}, bannerDetails = {}, showViewAllWidget = false) {
  const { platform, heading, displayRatings = false } = widgetData;
  const {
    feedLogic = '',
    widgetLevel = '',
    noOfProducts = 0,
    enableAdsOnPlp = false,
    showDefault = '',
    bannerType=''
  } = bannerDetails;

  const url = `/api/p/fetchDynamicProducts/${feedLogic}/?${qs.stringify({
    widgetLevel,
    platform,
    widgetName: heading || '',
    noOfProducts,
    enableAdsOnPlp,
    showViewAllWidget,
    showDefault,
    displayRatings,
    bannerType
  })}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

function fetchCuratedProductsApi(widgetData = {}, bannerDetails = {}) {
  const { heading } = widgetData;
  const { feedLogic = '', widgetLevel = '', showDefault = '' } = bannerDetails;

  const url = `/api/p/fetchCuratedProducts/${feedLogic}/?${qs.stringify({
    widgetLevel,
    widgetName: heading || '',
    showDefault
  })}`;
  return fetcher(url, fetchGetJSONReqOpts());
}

function fetchJioAdsSapiApi(data) {
  const { productCode='', brickCode='', segmentName='', verticalName='', asi = '', mnp = 0 } = data;
  const reqObj = {
    brickCode: brickCode,
    productId: productCode,
    segmentName,
    verticalName,
    asi,
    mnp
  };
  const url = `/api/p/fetchJioAdsSapi`;
  return fetcher(
      url,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(reqObj)
      })
    )
}

function fetchProductsDetailsPending() {
  return {
    type: 'FETCH_PRODUCTS_DETAIL_PENDING',
    payload: {
      loading: true,
      data: []
    }
  };
}

function fetchJioAdsProductsDetailsPending() {
  return {
    type: 'FETCH_JIOADS_PRODUCTS_DETAIL_PENDING',
    payload: {
      loading: true,
      data: []
    }
  };
}

function fetchProductsDetailsSuccess(response, index) {
  const {
    products = [],
    priceRevealMetaInfo,
    currentQuery: { url: dynamicPageUrl = '' } = {}
  } = response;
  return {
    type: 'FETCH_PRODUCTS_DETAIL_SUCCESS',
    payload: {
      loading: false,
      data: {
        [index]: products,
        priceRevealMetaInfo,
        [`priceRevealMetaInfo ${index}`]: priceRevealMetaInfo,
        [`redirectUrl ${index}`]: '/d2c-fashion/c/83' // as this is coming encoded from the backend side due to XSS issue we have to decode this #402372
      }
    }
  };
}

function fetchJioAdsProductsDetailsSuccess(response, position) {
  return {
    type: 'FETCH_JIOADS_PRODUCTS_DETAIL_SUCCESS',
    payload: {loading: false, jioAdsProducts:{ [`jioAdsProducts${position}`] : response}}
  };
} 

function fetchJioAdsProductsDetailsFailue(error) {
  return {
    type: 'FETCH_JIOADS_PRODUCTS_DETAIL_FAILURE',
    payload: {
      loading: false,
      data: [],
      error
    }
  };
}
function fetchCuratedProductsDetailsSuccess(response, index) {
  return {
    type: 'FETCH_PRODUCTS_DETAIL_SUCCESS',
    payload: {
      loading: false,
      data: {
        [index]: response,
      }
    }
  };
}

function fetchProductsDetailsFailue(error) {
  return {
    type: 'FETCH_PRODUCTS_DETAIL_FAILURE',
    payload: {
      loading: false,
      data: [],
      error
    }
  };
}

export function getProductsDetails(productIds, index = '0') {
  return (dispatch, getState) => {
    dispatch(fetchProductsDetailsPending());

    const states = getState();       
    const flags = getAmplitudeVariantPayload('searchExpFlags',states, getSearchFlags(states));
    

    let ABFlagObj = (states?.flags?.amplitude_experiment_flag == 'ON') ? getAmplitudeVariantPayloadMap(flags, states) : getSearchExpFlags(flags);
    

    return fetchProductsApi(productIds, ABFlagObj)
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(fetchProductsDetailsSuccess(response, index));
      })
      .catch(error => {
        dispatch(fetchProductsDetailsFailue(error));
      });
  };
}

export function getDynamicProductsDetails(
  widgetDetails = {},
  bannerDetails = {},
  showViewAllWidget = false,
  index = '0'
) {
  return dispatch => {
    dispatch(fetchProductsDetailsPending());
    return fetchDynamicProductsApi(widgetDetails, bannerDetails, showViewAllWidget)
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(fetchProductsDetailsSuccess(response, index));
      })
      .catch(error => {
        dispatch(fetchProductsDetailsFailue(error));
      });
  };
}

export function getCuratedProductsDetails(widgetDetails = {}, bannerDetails = {}, index = '0') {
  return dispatch => {
    dispatch(fetchProductsDetailsPending());
    return fetchCuratedProductsApi(widgetDetails, bannerDetails)
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(fetchCuratedProductsDetailsSuccess(response, index));
      })
      .catch(error => {
        dispatch(fetchProductsDetailsFailue(error));
      });
  };
}

function extractProductIds(data, adSpotId) {
  const result = data?.result || [];
  const ids = [];

  for (const asiKey in result) {
    const ads = result[asiKey]?.[adSpotId]?.ads;
    if (ads && typeof ads === 'object') {
      ids.push(...Object.keys(ads));
    }
  }

  return ids.join(', ');
}

export function getJioAdsProducts(data={}, position) {
  const payload = data;
  return async (dispatch, getState) => {
    dispatch(fetchJioAdsProductsDetailsPending());

    const state = getState();
    const flags = getSearchFlags(state);
    const ABFlagObj = getSearchExpFlags(flags);
    const params = { includeOOS: false };
    const adSpotId = data?.asi
    try {
      const jioAdsResponse = await fetchJioAdsSapiApi(payload).then(fetchGetJSONResHandler);

      //TODO: You need to extract `productIds` and possibly `index` from the response
      const productIds = extractProductIds(jioAdsResponse, adSpotId);

      // const productDetailsResponse = await fetchProductsApi(productIds, ABFlagObj, params)
      return fetchProductsApi(productIds, ABFlagObj, params)
      .then(fetchGetJSONResHandler)
      .then(response => {
        const refactored = getProductProps(response?.products)
        dispatch(fetchJioAdsProductsDetailsSuccess(refactored,position));
      })
      .catch(error => {
        dispatch(fetchJioAdsProductsDetailsFailue(error));
      });
      //TODO: update state
    } catch (error) {
      dispatch(fetchJioAdsProductsDetailsFailue(error));
    }
  };
};
